// Explicit stable control identities; no button-label or icon guessing.
// Unlisted legacy controls remain in the coverage audit until migrated.
import { pagePolicy } from './pagePolicies';

const controls = {
  'new-loan-btn': 'finance.loan.create', 'loan-create-save': 'finance.loan.create',
  'loan-extend-schedule': 'finance.loan.edit',
  'convert-challan-btn': 'operations.challan.convert', 'conversion-submit-button': 'operations.challan.convert',
  'new-fd-btn': 'finance.fd_bg.create', 'create-fd-btn': 'finance.fd_bg.create',
  'new-bg-btn': 'finance.fd_bg.create', 'create-bg-btn': 'finance.fd_bg.create',
  'transfer-approve-button': 'operations.site_transfer.approve', 'quick-complete-btn': 'operations.site_transfer.approve',
  'transfer-close-button': 'operations.site_transfer.edit',
  'transfer-dispatch-button': 'operations.site_transfer.create', 'transfer-receive-button': 'operations.site_transfer.create',
  'transfer-return-button': 'operations.site_transfer.create',
  'add-staff-btn': 'finance.salary.create', 'run-payroll-btn': 'finance.salary.create',
  'confirm-pay-btn': 'finance.salary.create', 'native-salary-save': 'finance.salary.create',
};

export const controlPermission = (path, id = '') => {
  if (controls[id]) return controls[id];
  if (/^\/salary(?:\/|$)/.test(path) && /^(mobile-pay-btn-|pay-btn-)/.test(id)) return 'finance.salary.create';
  if (path === '/salary/payments' && id === 'new-payment-btn') return 'finance.salary.create';
  if (path === '/roznamcha/expenses' && /^(check|reject)-\d+$/.test(id)) return 'finance.roznamcha.approve';
  if (['/fd', '/bg'].includes(path) && /^(close-fd-|close-bg-|confirm-close)/.test(id)) return 'finance.fd_bg.edit';
  if (/^\/reports\/(loan-interest|bank-book|site-cost)$/.test(path)) {
    const base = pagePolicy(path).resources[0];
    if (id === 'source-report-apply') return `${base}.view`;
    if (id === 'source-report-export') return `${base}.export`;
  }
  return null;
};